import { render, staticRenderFns } from "./Cotizar.vue?vue&type=template&id=c728e6a0&"
import script from "./Cotizar.vue?vue&type=script&lang=js&"
export * from "./Cotizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports